<template>

<core-filter-advanced-group title="Families" :count="count">

	<core-filter-input-suggest placeholder="Start typing a family name..." :toggle="true" field="family_name" :filter="value('families')" api="families/suggest" data="families" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {
			fields: ['families']
		}
	}

}

</script>